<template>
  <div v-if="showTimer && remainingTime > 0" class="countdown">
    <span class="long">Closing</span>
    <span class="short">Closes</span>
    in {{ remainingTime }}
    <span class="long">seconds</span>
    <span class="short">s</span>
  </div>
</template>

<script setup>
import {computed, onMounted, onUnmounted, ref} from "vue";

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const props = defineProps(["timeout", "callback"]);
const remainingTime = ref(props.timeout);
let timer = null;

// Show timer only if timeout is valid and greater than zero
const showTimer = computed(() => {
  return props.timeout !== undefined && props.timeout > 0;
});

const startTimer = () => {
  if (!showTimer.value) return;
  timer = setInterval(() => {
    if (remainingTime.value > 1) {
      remainingTime.value--;
    } else {
      clearInterval(timer);
      remainingTime.value = 0; // Ensure no negative value is shown
      if (props.callback) props.callback(); // Notify parent when timer reaches zero
    }
  }, 1000);
};

log(`timeout = ${props.timeout}`);

onMounted(() => startTimer());
onUnmounted(() => clearInterval(timer));
</script>

<style scoped>
.countdown {
  font-size: var(--font-size-small);
  color: var(--base-black-softer);
  /* background-color: rgba(0, 0, 0, 0.7); */
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}
span.long {
  display: inline;
}
span.short {
  display: none;
}
:is(.narrow-window, .medium-window) span.long {
  display: none !important;
}
:is(.narrow-window, .medium-window) span.short {
  display: inline;
}
</style>
